import React from 'react';
import { Col } from 'reactstrap';
import ComponentCard from '../../layouts/containers/ComponentCard';
import FormularioCliente from '../../components/clientes/FormularioCliente';

const NuevoCliente = () => {
  return (
    <Col md="12">
      <ComponentCard title="Nuevo Cliente" hasButton>
        <FormularioCliente isNew />
      </ComponentCard>
    </Col>
  );
};

export default NuevoCliente;
